import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  NumberIncrementStepper,
  NumberInputStepper,
  NumberInputField,
  NumberInput,
  FormLabel,
  NumberDecrementStepper,
  useDisclosure,
  Text,
  VStack,
  HStack
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { SiSap } from 'react-icons/si'

import useMrpDistribution from '@hook/mrp/use-distribution'

import Filter from '@component/Shared/Filter'

import { ILayoutActionSuppliers } from '@base/@types/components/Layout/Tools'

import LayoutToolsButton from '../Components/Button'

const ActionPurchaseCreateOrderSapDistribuition: FC<ILayoutActionSuppliers> =
  () => {
    const {
      handleUpdateSapParams,
      paramsSap,
      exportDataSap,
      exportDataSapFormatada,
      supplyMethod,
      discountSupply,
      sendingOrder
    } = useMrpDistribution()
    const { isOpen, onOpen, onClose } = useDisclosure()

    const [valueDesconto, setDesconto] = useState('')

    const handleOpenModal = () => {
      setDesconto(paramsSap.desconto ? paramsSap.desconto.toString() : '')
      onOpen()
    }

    const handleModalClose = () => {
      // Não fecha no meio do envio
      if (sendingOrder) return
      onClose()
    }

    // Envio direto (como na release): cria o pedido e fecha o modal
    const handleCreate = (formatado: boolean) => {
      if (sendingOrder) return
      onClose()
      if (formatado) {
        exportDataSapFormatada()
      } else {
        exportDataSap()
      }
    }

    const validateSap = () => {
      if (
        discountSupply.metodoPagamentoId === paramsSap.metodoPagamento[0]?.value
      ) {
        if (Number(valueDesconto) < Number(discountSupply.desconto)) {
          setDesconto(discountSupply.desconto.toString())
        }
      }
    }
    const defaultDiscount = (value: any) => {
      if (discountSupply.metodoPagamentoId === value[0]?.value) {
        setDesconto(discountSupply.desconto.toString())
      }
    }

    return (
      <>
        <LayoutToolsButton
          label="Criar Pedidos"
          onClick={handleOpenModal}
          isLoading={sendingOrder}
        />
        <Modal
          isOpen={isOpen}
          onClose={handleModalClose}
          size="xl"
          scrollBehavior="inside"
        >
          <ModalOverlay />
          <ModalContent transition="all ease .3s">
            <ModalHeader
              bgColor="white"
              display="flex"
              alignItems="center"
              gap={2}
            >
              <Text>Criar Pedido SAP</Text>
              <SiSap color="#0073C6" />
            </ModalHeader>

            <ModalCloseButton />
            <ModalBody bgColor="white" py={6}>
              <VStack spacing={6} align="stretch">
                <FormControl id="discount">
                  <FormLabel>Desconto (%)</FormLabel>
                  <NumberInput
                    value={valueDesconto}
                    onChange={value => setDesconto(value)}
                    onBlur={(event: any) => {
                      validateSap()
                      handleUpdateSapParams({
                        name: 'desconto',
                        value: event.target.value
                      })
                    }}
                  >
                    <NumberInputField borderColor="gray.300" />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
                <Filter
                  label="Forma de Pagamento"
                  options={supplyMethod.map(paymentMethod => ({
                    label: `${paymentMethod.codigo} - ${paymentMethod.descricao}`,
                    value: paymentMethod.id
                  }))}
                  value={paramsSap.metodoPagamento}
                  isMulti
                  onChange={value => {
                    defaultDiscount(value)
                    handleUpdateSapParams({ name: 'metodoPagamento', value })
                  }}
                />
              </VStack>
            </ModalBody>
            <ModalFooter bgColor="white">
              <HStack>
                <Button variant="ghost" onClick={handleModalClose}>
                  Cancelar
                </Button>
                <Button
                  onClick={() => handleCreate(false)}
                  isDisabled={!supplyMethod || sendingOrder}
                >
                  Criar Pedido
                </Button>
                <Button
                  colorScheme="blue"
                  onClick={() => handleCreate(true)}
                  isDisabled={!supplyMethod || sendingOrder}
                >
                  Criar Pedido SAP Formatado
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }

export default ActionPurchaseCreateOrderSapDistribuition
